import { forwardRef, useId } from 'react';
import { controlClassName } from 'components/list/styles';

const Input = forwardRef(function Input(
  {
    as: Tag = 'input',
    label,
    labelProps,
    containerProps,
    error,
    hint,
    className = '',
    id,
    required,
    ...props
  },
  ref
) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const message = error || hint;
  const messageId = `${inputId}-message`;
  const input = (
    <Tag
      {...props}
      ref={ref}
      id={inputId}
      required={required}
      aria-invalid={error ? true : props['aria-invalid']}
      aria-describedby={
        [props['aria-describedby'], message && messageId].filter(Boolean).join(' ') || undefined
      }
      className={`${controlClassName} ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''} ${className}`}
    />
  );
  if (!label && !message) return input;
  return (
    <div {...containerProps} className={`min-w-0 space-y-2 ${containerProps?.className || ''}`}>
      {label && (
        <label
          {...labelProps}
          htmlFor={inputId}
          className={`block text-sm font-medium text-gray-700 ${labelProps?.className || ''}`}
        >
          {label} {required && <span className='text-red-600'>*</span>}
        </label>
      )}
      {input}
      {message && (
        <p id={messageId} className={`text-xs ${error ? 'text-red-600' : 'text-gray-500'}`}>
          {message}
        </p>
      )}
    </div>
  );
});

export default Input;
